const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/resources/exercises/$exerciseId.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/resources/exercises/$exerciseId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { getCatalogExerciseQuery } from '@/features/workouts/lib/get-catalog-exercise.query';
import { listCatalogMusclesQuery } from '@/features/workouts/lib/list-catalog-muscles.query';
export const Route = createFileRoute('/_authenticated/resources/exercises/$exerciseId')({
  beforeLoad: ({
    context,
    params
  }) => {
    const validated = context.deps.validators.exerciseIdValidator.validate(params.exerciseId);
    if (!validated.ok) {
      throw redirect({
        to: '/resources/exercises'
      });
    }
    return {
      exerciseId: validated.data
    };
  },
  loader: async ({
    context,
    location
  }) => {
    const deps = {
      controllers: {
        workoutController: context.deps.controllers.workoutController
      }
    };
    try {
      await Promise.all([context.queryClient.ensureQueryData(getCatalogExerciseQuery(deps, context.exerciseId)), context.queryClient.ensureQueryData(listCatalogMusclesQuery(deps))]);
    } catch (error) {
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});